import dayjs from 'dayjs'

const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss"

export const convertDate = (unixDate) => {
  return dayjs.unix(unixDate).format(DATETIME_FORMAT);
}